/**
 * Markets query
 * @param alias {string} - for renaming the query for ease of use
 */
const markets = (alias = "markets") => `
  ${alias ? `${alias}:` : ""} getMarkets {
    locale
    marketName
    countryCode
    cmsLocale
    languageCode
    languageName
    region
    apiRegion
    dateFormat
    features
    marketType
  }
`;
export default markets;
